import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=5119f516&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"
import style0 from "./Initial.vue?vue&type=style&index=0&id=5119f516&prod&lang=css"
import style1 from "./Initial.vue?vue&type=style&index=1&id=5119f516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119f516",
  null
  
)

export default component.exports